import React from 'react';
import { Box } from '@mui/material';
import Banner from './Banner';
import Signup from './Signup';
import InfoSection from './InfoSection';
import Founders from "./Founders";

const sections = [
    {
        title: 'We Predict Human Behavior in Market Still Moved by Humans',
        body: `**SME stocks aren’t dominated by algorithms or institutions.**\nThey move with stories, emotions and psychology – and that’s exactly what our AI was built to understand.\n\n**See the Signals Before the Crowd.**`,
        image: '/images/We predict human behavior.png',
        video: '/videos/Introduction.mp4',
        background: 'light',
        boxWidth: 600,
        boxHeight: 350,
    },
    {
        title: 'Sign Up Now',
        highlight: 'Get 3 Months Free!',
        body: `Our revolutionary app is launching soon. Get early access and get rewarded with 3 months free subscription!`,
        image: '/images/gen-ai-text.png',
        imageLeft: true,
        background: 'dark',
        boxWidth: 600,
        boxHeight: 350,
        button: {
            label: 'Early Access',
            href: 'mailto:earlyaccess@genaisignal.com',
        },
    },
    {
        title: 'We see things before the crowd',
        body: `The best predictions starts 15 days prior to a corporate action.\nOnly GenAI Signal can sense the small shifts of movements that sets off larger trading volumes.`,
        image: '/images/ögat.png',
        video: '/videos/How it Works.mp4',
        background: 'light',
        boxWidth: 600,
        boxHeight: 350,
    },
    {
        title: 'Independent Thesis: AI vs. Traditional Analytic Tools',
        body: `We commissioned, independent from each other, three groups of students from KTH Royal Institute of Technology to compare AI with existing stock analysis tools in predicting future share price movements.`,
        image: '/images/brain.jpg',
        imageLeft: true,
        background: 'dark',
        extra: {
            title: 'The result:',
            highlight: 'AI outperformed traditional\nmethods every time!',
        },
        boxWidth: 600,
        boxHeight: 350,
    },
    {
        title: 'We don’t predict value.\nWe predict movement.',
        body: `**Markets are no longer rational – they are responsive.**\nBy listening to the market noise and determine human behaviors our billions of datapoints can decode the intents and determine the patterns before anyone else.`,
        image: '/images/gen_ai_mobile.png',
        video: '/videos/Tutorial.mp4',
        imageLeft: true,
        background: 'dark',
        boxWidth: 600,
        boxHeight: 600,
    },
    {
        title: 'We are first out using a full AI for SMEs',
        body: `AI-driven SME-predictive platform for traders using Deep Learning with (ML) supervised, unsupervised and reinforced learning (RL) in combination with Large Language Model (LLM).`,
        image: '/images/AI learning skiss.png',
        video: '/videos/Tech Break Down.mp4',
        background: 'dark',
        boxWidth: 500,
        boxHeight: 600,
    },
];

const Homepage: React.FC = () => {
    return (
        <>
            <Box mt={6} sx={{ backgroundColor: '#000000' }}>
                <Banner />
            </Box>

            {sections.map((section, index) => (
                <InfoSection key={index} {...section} />
            ))}

            <Founders />

            <Box mt={6}>
                <Signup />
            </Box>
        </>
    );
};

export default Homepage;
